<script setup lang="ts">
defineEmits<{ logout: [] }>()
</script>

<template>
  <div class="flex min-h-screen items-center justify-center p-4">
    <AuthCard class="w-full sm:w-[400px]" title="You do not have access...">
      <div class="flex flex-1 flex-col justify-between">
        <p class="text-sm leading-[21px] text-neutral-700">
          Unfortunately, your permissions do not allow access to this app.
          Please reach out to
          <a
            class="text-secondary hover:underline"
            href="mailto:support@rialtic.io"
            rel="noopener"
            target="_blank"
          >
            support@rialtic.io
          </a>
          or your company's primary Rialtic contact for further assistance.
        </p>
        <UButton class="justify-center" block @click="$emit('logout')">
          Log out
        </UButton>
        <div />
      </div>
    </AuthCard>
  </div>
</template>
